module.exports = __webpack_public_path__ + "static/img/img_5.cf8a2cad.png";